import axiosClient from "../../../../system/helpers/axiosConfig";

export const getProgramTypes = () => {
  return axiosClient.get("api/admin/programs/types").then((r) => r.data);
};
